"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _default = {
  created: function created() {
    this.tableLayout.addObserver(this);
  },
  destroyed: function destroyed() {
    this.tableLayout.removeObserver(this);
  },
  computed: {
    tableLayout: function tableLayout() {
      var layout = this.layout;

      if (!layout && this.table) {
        layout = this.table.layout;
      }

      if (!layout) {
        throw new Error('Can not find table layout.');
      }

      return layout;
    }
  },
  mounted: function mounted() {
    this.onColumnsChange(this.tableLayout);
    this.onScrollableChange(this.tableLayout);
  },
  updated: function updated() {
    if (this.__updated__) return;
    this.onColumnsChange(this.tableLayout);
    this.onScrollableChange(this.tableLayout);
    this.__updated__ = true;
  },
  methods: {
    onColumnsChange: function onColumnsChange() {
      var cols = this.$el.querySelectorAll('colgroup > col');
      if (!cols.length) return;
      var flattenColumns = this.tableLayout.getFlattenColumns();
      var columnsMap = {};
      flattenColumns.forEach(function (column) {
        columnsMap[column.id] = column;
      });

      for (var i = 0, j = cols.length; i < j; i++) {
        var col = cols[i];
        var name = col.getAttribute('name');
        var column = columnsMap[name];

        if (column) {
          var width = column.realWidth || column.width; // if (this.fixePx) {
          //   width = this._rem2px(width)
          // }

          col.setAttribute('width', width);
        }
      }
    },
    onScrollableChange: function onScrollableChange(layout) {
      var cols = this.$el.querySelectorAll('colgroup > col[name=gutter]');

      for (var i = 0, j = cols.length; i < j; i++) {
        var col = cols[i];
        var width = layout.scrollY ? layout.gutterWidth : '0'; // if (this.fixePx) {
        //   width = this._rem2px(width)
        // }

        col.setAttribute('width', width);
      }

      var ths = this.$el.querySelectorAll('th.gutter');

      for (var _i = 0, _j = ths.length; _i < _j; _i++) {
        var th = ths[_i];
        th.style.width = layout.scrollY ? layout.gutterWidth + 'px' : '0'; // th.style.display = layout.scrollY ? '' : 'none';

        /** 扩展 显示隐藏列宽度问题 */

        th.style.display = '';
        /** */
      }
    }
  }
};
exports["default"] = _default;